import axios from 'axios';

import config from 'config';

const instances = {
  auth: axios.create({ baseURL: config.api.baseUrl }),
  nonAuth: axios.create({ baseURL: config.api.baseUrl }),
  youtube: axios.create({ baseURL: config.rtmp.youtube.baseUrl }),
  facebook: axios.create({ baseURL: config.rtmp.facebook.baseUrl }),
  twitch: axios.create({ baseURL: config.rtmp.twitch.baseUrl })
};

export default instances;
